var _excluded = ["afterClose", "className", "getArrow", "getPopper", "hideToDestroy", "lazyInit", "zIndex", "show", "defaultShow", "onShow", "onHide", "onVisibleChange", "placement", "scaleAnimation", "popoverId", "singleGroupId", "offset", "preventOverflow", "boundariesDetectionDebounce", "overflowBoundaries", "preventAroundOverflow", "arrow", "arrowOffset", "captureOptions", "refType", "refId", "triggerIds", "unionPopoverIds", "wrapperClassName", "popoverClassName", "disableAnimation", "getPopupContainer", "followTrigger", "defaultToBody"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { classnames } from '@okee-uikit/react-utils';
import { getDefaultElementPosition, getDocScroll, getZIndex, isFixed, useElementPosition, useRefCallback, isClient } from '@okee-uikit/react-hooks';
import { usePrefixCls } from '@okee-uikit/react-config';
import { LayerContext } from '../../context/layer';
import { useCSSEnterLeave } from '../../hooks/animation';
import { RcPortal } from '../../hooks/portal';
import { touchReverse, usePopover } from '../../hooks/popper';
import { useLayer } from '../../hooks/useLayer';
export function RcPopover(props) {
  var _usePrefixCls;

  var afterClose = props.afterClose,
      className = props.className,
      getArrow = props.getArrow,
      getPopper = props.getPopper,
      hideToDestroy = props.hideToDestroy,
      lazyInit = props.lazyInit,
      zIndex = props.zIndex,
      show = props.show,
      defaultShow = props.defaultShow,
      onShow = props.onShow,
      onHide = props.onHide,
      onVisibleChange = props.onVisibleChange,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom-start' : _props$placement,
      _props$scaleAnimation = props.scaleAnimation,
      scaleAnimation = _props$scaleAnimation === void 0 ? 'xy' : _props$scaleAnimation,
      popoverId = props.popoverId,
      singleGroupId = props.singleGroupId,
      offset = props.offset,
      preventOverflow = props.preventOverflow,
      boundariesDetectionDebounce = props.boundariesDetectionDebounce,
      overflowBoundaries = props.overflowBoundaries,
      preventAroundOverflow = props.preventAroundOverflow,
      arrow = props.arrow,
      arrowOffset = props.arrowOffset,
      _props$captureOptions = props.captureOptions,
      captureOptions = _props$captureOptions === void 0 ? {} : _props$captureOptions,
      refType = props.refType,
      refId = props.refId,
      triggerIds = props.triggerIds,
      unionPopoverIds = props.unionPopoverIds,
      wrapperClassName = props.wrapperClassName,
      popoverClassName = props.popoverClassName,
      disableAnimation = props.disableAnimation,
      getPopupContainer = props.getPopupContainer,
      _props$followTrigger = props.followTrigger,
      followTrigger = _props$followTrigger === void 0 ? !getPopupContainer : _props$followTrigger,
      _props$defaultToBody = props.defaultToBody,
      defaultToBody = _props$defaultToBody === void 0 ? false : _props$defaultToBody,
      htmlElementProps = _objectWithoutProperties(props, _excluded);

  var zIndexRef = useRef(zIndex !== null && zIndex !== void 0 ? zIndex : 1);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      appearedCauseOfMotion = _useState2[0],
      setAppearedCauseOfMotion = _useState2[1];

  var arrowRef = useRef(null);
  var elementRef = useRef(null);
  var popoverRef = useRef(null);
  var arrowInfoRef = useRef(null);
  var arrowStyleRef = useRef(null);
  var popoverStyleRef = useRef(null);

  var _usePopover = usePopover({
    popoverId: popoverId,
    singleGroupId: singleGroupId,
    offset: offset,
    preventOverflow: preventOverflow,
    boundariesDetectionDebounce: boundariesDetectionDebounce,
    overflowBoundaries: overflowBoundaries,
    preventAroundOverflow: preventAroundOverflow,
    arrow: arrow,
    arrowOffset: arrowOffset,
    onShow: onShow,
    onHide: onHide,
    captureOptions: captureOptions,
    refType: refType,
    refId: refId,
    triggerIds: triggerIds,
    unionPopoverIds: unionPopoverIds,
    onVisibleChange: onVisibleChange,
    arrowRef: arrowRef,
    show: show,
    defaultShow: defaultShow,
    popoverRef: popoverRef,
    placement: placement
  }),
      popover = _usePopover.popover,
      touch = _usePopover.touch;

  var mountRef = useRef(popover.isShow() || !lazyInit);
  var getLayerContainer = useLayer(defaultToBody);
  var getContainer = typeof getPopupContainer === 'function' ? getPopupContainer : getLayerContainer;
  var container = getContainer();
  var containerPos = useElementPosition(container, function () {
    return popover.isShow();
  }, function () {
    return void 0;
  }, {});

  if (typeof window === 'undefined' || container === document.body || container == null) {
    containerPos = getDefaultElementPosition();
  } else {
    var documentScroll = popover.getRefFixed() ? {
      scrollLeft: 0,
      scrollTop: 0
    } : getDocScroll();
    containerPos = _objectSpread(_objectSpread({}, containerPos), {}, {
      left: containerPos.left + documentScroll.scrollLeft,
      top: containerPos.top + documentScroll.scrollTop
    });
  }

  var handlePopoverStyleChange = useRefCallback(function (nextStyle) {
    if (popoverStyleRef.current && isUncertainPosition(popover)) {
      nextStyle = popoverStyleRef.current;
    }

    if (popoverRef.current && followTrigger) {
      Object.assign(popoverRef.current.style, _objectSpread(_objectSpread({}, nextStyle), {}, {
        position: container && isFixed(container) ? 'absolute' : nextStyle.position,
        left: "".concat(parseFloat(nextStyle.left) - containerPos.left, "px"),
        top: "".concat(parseFloat(nextStyle.top) - containerPos.top, "px")
      }));
    }
  });
  var handleArrowInfoChange = useRefCallback(function () {
    if (arrowRef.current && isUncertainPosition(popover)) {
      Object.assign(arrowRef.current.style, arrowStyleRef.current);
    }
  });
  var handleMouseEnter = useCallback(function () {
    popover.onPopperMouseEnter();
  }, []);
  var handleMouseLeave = useCallback(function () {
    popover.onPopperMouseLeave();
  }, []);
  var handleFocus = useCallback(function () {
    popover.onPopperFocus();
  }, []);
  var handleBlur = useCallback(function () {
    popover.onPopperBlur();
  }, []);
  var realPlacement = useMemo(function () {
    var splited = placement.split('-');
    var reversed = ['top', 'bottom'].includes(splited[0]) ? touch.touchY : touch.touchX;
    splited[0] = reversed ? touchReverse[splited[0]] : splited[0];
    return splited.join('-');
  }, [placement, touch]);
  var disableLeaveMotion = !!disableAnimation;
  var disableEnterMotion = disableAnimation === true;
  var shouldApplyEnterMotion = popover.isShow() && !appearedCauseOfMotion && !disableEnterMotion;
  var shouldApplyLeaveMotion = !popover.isShow() && appearedCauseOfMotion && !disableLeaveMotion;
  var isAppeared = popover.isShow() && (appearedCauseOfMotion || disableEnterMotion);
  var isDisplayed = popover.isShow() || appearedCauseOfMotion && !disableLeaveMotion;
  var wrapperCls = usePrefixCls('popover-wrapper');
  var innerCls = usePrefixCls('popover-inner');
  var popperCls = classnames(usePrefixCls('popover', (_usePrefixCls = {
    show: isAppeared,
    scale: scaleAnimation
  }, _defineProperty(_usePrefixCls, realPlacement, true), _defineProperty(_usePrefixCls, 'disable-animation', disableEnterMotion && disableLeaveMotion), _usePrefixCls)), popoverClassName);

  var handleEnterStart = function handleEnterStart() {
    if (shouldApplyEnterMotion) {
      setAppearedCauseOfMotion(true);
    }
  };

  var handleLeaveEnd = function handleLeaveEnd() {
    if (shouldApplyLeaveMotion) {
      mountRef.current = hideToDestroy ? false : mountRef.current;
      setAppearedCauseOfMotion(false);
      afterClose === null || afterClose === void 0 ? void 0 : afterClose();
    }
  };

  useEffect(function () {
    popover.addListener('popover-style', handlePopoverStyleChange);
    popover.addListener('arrow-info-change', handleArrowInfoChange);
    return function () {
      popover.removeListener('popover-style', handlePopoverStyleChange);
      popover.removeListener('arrow-info-change', handleArrowInfoChange);
    };
  }, []);
  useCSSEnterLeave(popoverRef, {
    type: 'transition',
    show: popover.isShow(),
    validTarget: elementRef,
    validProperty: 'transform',
    disabled: disableEnterMotion && disableLeaveMotion,
    enter: {
      onStart: handleEnterStart
    },
    leave: {
      onEnd: handleLeaveEnd
    }
  });
  useMemo(function () {
    if (popover.isShow()) {
      mountRef.current = true;
      zIndexRef.current = zIndex !== null && zIndex !== void 0 ? zIndex : getZIndex();
    }
  }, [popover.isShow(), zIndex]);
  var popperNode = useMemo(function () {
    return React.createElement("div", {
      className: innerCls
    }, typeof getPopper === 'function' ? getPopper(popover.getLastTrigger() ? popover.getTriggerData() : null) : getPopper);
  }, [innerCls, getPopper, popover, popover.getLastTrigger()]);

  if (!mountRef.current) {
    return null;
  }

  if (!isClient()) {
    return null;
  }

  if (!isUncertainPosition(popover) || !arrowStyleRef.current || !popoverStyleRef.current) {
    arrowInfoRef.current = popover.arrowInfo;
    arrowStyleRef.current = popover.getArrowStyle();
    popoverStyleRef.current = popover.getPopoverStyle();
  }

  return React.createElement(RcPortal, {
    getContainer: getContainer
  }, React.createElement(LayerContext.Provider, {
    value: popoverRef
  }, React.createElement("div", {
    ref: popoverRef,
    id: popoverId,
    "data-rc-id": "popover___".concat(popover.getId()),
    className: classnames(wrapperCls, wrapperClassName),
    onMouseLeave: handleMouseLeave,
    onMouseEnter: handleMouseEnter,
    onFocusCapture: handleFocus,
    onBlurCapture: handleBlur,
    style: _objectSpread(_objectSpread({
      position: 'absolute',
      zIndex: zIndexRef.current,
      display: isDisplayed ? undefined : 'none'
    }, popoverStyleRef.current), {}, {
      left: "".concat(parseFloat(popoverStyleRef.current.left) - containerPos.left, "px"),
      top: "".concat(parseFloat(popoverStyleRef.current.top) - containerPos.top, "px")
    })
  }, React.createElement("div", _objectSpread(_objectSpread({}, htmlElementProps), {}, {
    className: classnames(popperCls, className),
    ref: elementRef
  }), popover.arrow && getArrow && React.createElement("span", {
    style: arrowStyleRef.current,
    ref: arrowRef
  }, getArrow(arrowInfoRef.current || popover.arrowInfo, touch)), popperNode))));
}

function isUncertainPosition(popover) {
  var refRect = popover.getRefRect();
  return !(refRect.width || refRect.height || refRect.top || refRect.left);
}